module.exports = __webpack_public_path__ + "static/media/vintage_leather_strap_dark_brown_side_stitch.8a435c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vintage_leather_strap_dark_brown_side_stitch.png
// module id = 126
// module chunks = 0